/** 与 Tailwind `md` 一致：小于 768px 使用手机专用登录页 */
export const LOGIN_VIEWPORT_QUERY = '(max-width: 767px)';

export function isMobileLoginViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(LOGIN_VIEWPORT_QUERY).matches;
}

export function getLoginPath(): string {
  return isMobileLoginViewport() ? '/m/login' : '/login';
}

/** 登录接口返回的 err 码 -> 文案 */
export function loginResponseMessage(err?: string): string {
  switch (err) {
    case 'bad_credentials':
      return '用户名或密码错误';
    case 'account_disabled':
      return '账号已禁用，请联系管理员';
    case 'account_expired':
      return '账号已超过有效期，请联系管理员';
    default:
      return '登录失败';
  }
}

/** 防止开放重定向：仅允许本站相对路径 */
export function safeInternalNextPath(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const t = String(raw).trim();
  if (t === '') return null;
  if (t.startsWith('//')) return null;
  if (/^[a-z][a-z0-9+.-]*:/i.test(t)) {
    try {
      const u = new URL(t);
      if (typeof window === 'undefined') return null;
      if (u.origin !== window.location.origin) return null;
      return u.pathname + u.search + u.hash;
    } catch {
      return null;
    }
  }
  if (!t.startsWith('/')) return null;
  return t;
}

export function getSessionExpiredLoginUrl(returnTo?: string): string {
  const path = returnTo && returnTo.length > 0 ? safeInternalNextPath(returnTo) : null;
  const base = getLoginPath();
  const p = new URLSearchParams();
  p.set('session', 'expired');
  if (path) p.set('next', path);
  return `${base}?${p.toString()}`;
}
